import { render, staticRenderFns } from "./NewCompeteIndex.vue?vue&type=template&id=0d2ab5d1&scoped=true&"
import script from "./NewCompeteIndex.vue?vue&type=script&lang=js&"
export * from "./NewCompeteIndex.vue?vue&type=script&lang=js&"
import style0 from "./NewCompeteIndex.vue?vue&type=style&index=0&id=0d2ab5d1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2ab5d1",
  null
  
)

export default component.exports